<template>
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">Hidrograma</h1>
            </div><!-- /.col -->
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                <li class="breadcrumb-item active">Hidrograma</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
      </div>
      <!-- /.content-header -->

      <!-- Main content -->
      <div class="content">
        <div class="container-fluid">

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Fecha</h5>

                  <div class="card-text">
                    <div class="row">
                      <div class="col-lg-12">
                        <datepicker v-model="fecha" class="d-print-none"></datepicker>
                        <h1>{{semana}}</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->

          <div class="d-flex flex-wrap">

            <template v-for="(chart,index) in charts">
              <div class="" v-bind:key="'chart'+index">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">{{chart.nombre}}</h5>
                    <div class="card-text">
                      <chartjs :chartData="chart.chartdata" :options="chartOptions" :width="200" :height="200"/>
                      <div class="progress-group">
                        Acumulado semanal
                        <span class="float-right"><b>{{chart.acumulado.val}}</b></span>
                        <div class="progress">
                          <div :class="'progress-bar ' + chart.acumulado.class" :style="'width: ' + chart.acumulado.ratio + '%'"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

          </div>
          <!-- /.row -->

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Mapa</h5>
                  <div class="card-text">
                    <div id="map"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->

          <template v-for="(traza,i) in analisis">
            <div class="row" v-bind:key="'analisis-'+i">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">{{traza.nombre}}</h5>
                    <div class="card-text">
                      <table class= "table table-bordered">
                        <tr><th>Nivel de Riesgo</th><th>Tramo</th><th>Segmento</th></tr>
                        <template v-if="traza.tramos.length">
                          <template v-for="(tramo,j) in traza.tramos">
                            <tr v-bind:key="'tr_'+i+'_'+j">
                              <td>{{texto_param(tramo.riesgo,'riesgo')}}</td>
                              <td>PK{{tramo.progresiva_inicial_texto}} - PK{{tramo.progresiva_final_texto}}</td>
                              <td>
                                <table style="width:100%">
                                  <template v-for="(segmento,k) in tramo.features">
                                    <tr v-if="segmento.properties.riesgo>2" v-bind:key ="'tr_'+i+'_'+j+'_'+k">
                                      <td :style="'background-color:'+color_riesgo(segmento.properties.riesgo)">
                                        <template v-if="segmento.properties.progresiva_inicial_texto">
                                          PK{{segmento.properties.progresiva_inicial_texto}} - PK{{segmento.properties.progresiva_final_texto}}
                                        </template>
                                        <template v-else>
                                          PK{{segmento.properties.progresiva_texto}}
                                        </template>
                                        {{texto_tipo(segmento.properties.tipo)}}
                                      </td>
                                    </tr>
                                  </template>
                                </table>
                              </td>
                            </tr>
                          </template>
                        </template>
                        <template v-else><tr><td colspan="3">No hay segmentos de alto riesgo</td></tr></template>
                      </table>
                      <div :id="'map_'+i"></div>
                      <div :id="'popup_'+i">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.row -->
          </template>

        </div><!-- /.container-fluid -->
      </div>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Chartjs from '../components/Chartjs'

import 'ol/ol.css'
import { Map, View } from 'ol'
import GeoJSON from 'ol/format/GeoJSON'
import { XYZ, Vector as VectorSource } from 'ol/source'
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer'
import { Fill, RegularShape, Stroke, Style, Text } from 'ol/style'
// import { defaults as defaultControls, Control, FullScreen, Attribution } from 'ol/control'
import { defaults as defaultControls, FullScreen, Attribution } from 'ol/control'
import { extend, createEmpty } from 'ol/extent'
import * as turf from '@turf/turf'

import pluviometrosJson from '../assets/geojson/pluviometros.json'

export default {
  name: 'Inicio',
  components: { Chartjs, Datepicker },
  data () {
    return {
      mapa: null,
      mapas: [],
      pluviometros: new GeoJSON(),
      pluviometrosArea: null,
      lluvia: null,
      urlconfig: null,
      analisis: null,
      fecha: null,
      charts: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Precipitación (mm)'
            },
            ticks: {
              min: 0,
              max: 10
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Minutos'
            }
          }]
        },
        tooltips: {
          callbacks: {
            title: function (tooltipItem, data) {
              return tooltipItem[0]['yLabel']
            },
            label: function (tooltipItem, data) {
              return 'mm'
            }
          }
        }
      }
    }
  },
  mounted: function () {
    var obj = this
    var attribution = new Attribution({
      // collapsible: false
    })
    obj.mapa = new Map({
      target: 'map',
      layers: [obj.getTileLayer()],
      view: new View({
        projection: 'EPSG:4326',
        center: [ -72.93, -11.7 ],
        zoom: 10
      }),
      controls: defaultControls({ attribution: false }).extend([
        new FullScreen(),
        attribution
      ])
    })

    this.loadTrazas()

    obj.mapa.addLayer(
      new VectorLayer({
        source: new VectorSource({
          features: (new GeoJSON()).readFeatures(pluviometrosJson)
        }),
        style: obj.pluviometro_style,
        zIndex: 999
      })
    )
  },
  methods: {
    getTileLayer () {
      var legend = 'LLUVIA<table>'
      for (var i = 0; i < 6; i++) {
        var color = 'rgba(' +
          String(236 - 99 * i + 19 * i * i) + ',' +
          String(241 - 26 * i - 1 * i * i) + ',' +
          String(121 + 73 * i - 11 * i * i) + ',' +
          '0.8)'
        legend = legend + '<tr><td style="background-color:' + color + '">&nbsp;&nbsp;&nbsp;&nbsp;</td><td> > ' + String(i * 30) + ' mm </td></tr>'
      }
      legend = legend + '</table>'
      return new TileLayer({
        source: new XYZ({
          attributions: legend + 'Tiles &copy; Esri',
          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
        })
      })
    },
    pluviometro_style (feature) {
      return new Style({
        image: new RegularShape({
          radius: 8.8,
          points: 4,
          stroke: new Stroke({ color: 'rgba(7,88,0,1.0)', lineDash: null, lineCap: 'butt', lineJoin: 'miter', width: 5 }),
          fill: new Fill({ color: 'rgba(84,176,74,1.0)' })
        }),
        text: new Text({
          font: '13.0px \'MS Shell Dlg 2\', sans-serif',
          text: String(feature.get('nombre')),
          textBaseline: 'middle',
          textAlign: 'left',
          offsetX: 8,
          offsetY: 3,
          placement: 'point',
          maxAngle: 0,
          stroke: new Stroke({ color: 'rgba(255,255,255,0.7)', lineDash: null, lineCap: 'butt', lineJoin: 'miter', width: 5 }),
          fill: new Fill({
            color: 'rgba(0, 0, 0, 1)'
          })
        })
      })
    },
    progresiva_style (feature) {
      return new Style({
        image: new RegularShape({
          radius: 10,
          points: 8,
          stroke: new Stroke({ color: 'rgba(88,88,88,1.0)', lineDash: null, lineCap: 'butt', lineJoin: 'miter', width: 1 }),
          fill: new Fill({ color: 'rgba(180,180,180,1.0)' })
        }),
        text: new Text({
          font: '12.0px \'MS Shell Dlg 2\', sans-serif',
          text: String(feature.get('progresiva')),
          textBaseline: 'middle',
          textAlign: 'center',
          offsetX: 0,
          offsetY: 0,
          placement: 'point',
          maxAngle: 0,
          fill: new Fill({
            color: 'rgba(0, 0, 0, 1)'
          })
        })
      })
    },
    loadTrazas () {
      var obj = this
      var style = [ new Style({
        stroke: new Stroke({ color: 'rgba(0,0,0,1.0)', lineDash: null, lineCap: 'round', lineJoin: 'round', width: 7 })
      }), new Style({
        stroke: new Stroke({ color: 'rgba(200,200,200,1.0)', lineDash: null, lineCap: 'round', lineJoin: 'round', width: 6 })
      })]
      this.$http.get(this.$store.state.apiurl + '/trazas/1',
        this.urlconfig).then(function (resp) {
        var features = []
        var extentx = createEmpty()

        var gjs = new GeoJSON()
        for (var i = 0; i < resp.data.length; i++) {
          features.push(gjs.readFeature(resp.data[i]))
          extentx = extend(extentx, features[features.length - 1].getGeometry().getExtent())
        }
        var v = new VectorLayer({
          source: new VectorSource({ features: features }),
          style: style,
          zIndex: 998
        })
        obj.mapa.addLayer(v)
        obj.mapa.getView().fit(extentx)
      })
    },
    actualizar (fecha) {
      var obj = this
      obj.charts = []
      obj.chartOptions.scales.yAxes[0].ticks.max = 10
      var url = this.$store.state.apiurl + '/hietogramas_semanal/1/' + fecha.getFullYear() + '/' + (fecha.getMonth() + 1) + '/' + fecha.getDate()
      this.$http.get(url, this.urlconfig).then(function (val) {
        for (var i = 0; i < val.data.hietogramas.length; i++) {
          var hietograma = val.data.hietogramas[i]
          var item = {
            'nombre': '',
            'id': 0,
            'chartdata': {
              'labels': [],
              'datasets': [
                {
                  'type': 'bar',
                  'label': 'Hidrograma',
                  'borderColor': 'rgb(30,30,255)',
                  'backgroundColor': 'rgba(30,30,255,0.7)',
                  'data': []
                }
              ]
            },
            'acumulado': {
              'val': 0,
              'class': '',
              'ratio': 0
            }
          }
          item.nombre = hietograma.nombre
          item.id = hietograma.id
          for (var j = 0; j < hietograma.lineas.length; j++) {
            item.chartdata.labels.push(hietograma.lineas[j].minutos)
            item.chartdata.datasets[0].data.push(hietograma.lineas[j].precipitacion)
            obj.chartOptions.scales.yAxes[0].ticks.max = Math.max(obj.chartOptions.scales.yAxes[0].ticks.max, hietograma.lineas[j].precipitacion)
          }
          for (j = 0; j < val.data.mapa.length; j++) {
            var feature = val.data.mapa[j]
            if (feature.id === hietograma.id) {
              item.acumulado.val = parseFloat(feature.properties.lluvia)
              item.acumulado.class = item.acumulado.val < 200 ? 'bg-success' : (item.acumulado.val < 300 ? 'bg-warning' : 'bg-danger')
              item.acumulado.ratio = Math.min(100, parseInt(item.acumulado.val / 4))
              break
            }
          }
          obj.charts.push(item)
        }
        var features = []
        var gjs = new GeoJSON()
        for (i = 0; i < val.data.mapa.length; i++) {
          feature = val.data.mapa[i]
          features.push(gjs.readFeature(feature))
        }
        if (obj.lluvia) {
          this.mapa.removeLayer(obj.lluvia)
        }
        obj.lluvia = new VectorLayer({
          source: new VectorSource({ features: features }),
          style: function (feature) {
            var escala = Math.min(Math.max(feature.get('lluvia') / 30, 0), 5)
            return new Style({
              fill: new Fill({
                color: 'rgba(' +
                  String(236 - 99 * escala + 19 * escala * escala) + ',' +
                  String(241 - 26 * escala - 1 * escala * escala) + ',' +
                  String(121 + 73 * escala - 11 * escala * escala) + ',' +
                  '0.8)'
              })
            })
          }
        })
        obj.mapa.addLayer(obj.lluvia)
        this.$http.get(
          this.$store.state.apiurl + '/proyectos_semana/' + fecha.getFullYear() + '/' + (fecha.getMonth() + 1) + '/' + fecha.getDate(),
          this.urlconfig).then(function (val2) {
          obj.analisis = []
          if (obj.mapas.length) {
            for (var m = 0; m < obj.mapas.length; m++) {
              obj.mapas[m].setTarget(null)
            }
          }
          obj.mapas = []
          var p = Promise.resolve()
          for (j = 0; j < val2.data.length; j++) {
            obj.analisis.push({
              'nombre': val2.data[j].traza__nombre,
              'tramos': []
            })
          }
          for (j = 0; j < val2.data.length; j++) {
            p = p.then(this.$http.get(
              this.$store.state.apiurl + '/proyecto_reporte/500/' + val2.data[j].id,
              this.urlconfig).then(
              function (nombre, j) {
                return function (val3) {
                  var features = []
                  var progresivas = new VectorSource()
                  var progresivas2 = new VectorSource()
                  var progresivas4 = new VectorSource()
                  var gjs = new GeoJSON()
                  var extentx = createEmpty()
                  var resto = 0
                  var contador = 1
                  for (var k = 0; k < val3.data.length; k++) {
                    var tramo = val3.data[k]
                    if (tramo.riesgo > 2) {
                      obj.analisis[j]['tramos'].push(tramo)
                    }
                    var fjson = {
                      'type': 'Feature',
                      'id': tramo.id,
                      'properties': {
                        'riesgo': tramo.riesgo
                      },
                      'geometry': tramo.geom
                    }
                    var f = gjs.readFeature(fjson)
                    features.push(f)
                    extentx = extend(extentx, f.getGeometry().getExtent())
                    var longitud = turf.length(fjson, { units: 'kilometers' })
                    for (var p = 1; p <= (longitud + resto); p++) {
                      var turfPoint = turf.along(fjson, p - resto, { units: 'kilometers' })
                      turfPoint.properties['progresiva'] = contador
                      var marker = gjs.readFeature(turfPoint)
                      // marker.getGeometry().transform('EPSG:4326', 'EPSG:3857');
                      if (contador % 4 === 0) {
                        progresivas4.addFeature(marker)
                      } else if (contador % 2 === 0) {
                        progresivas2.addFeature(marker)
                      } else {
                        progresivas.addFeature(marker)
                      }
                      contador += 1
                    }
                    resto = (resto + longitud) - Math.floor(resto + longitud)
                  }
                  var mapx = new Map({
                    target: 'map_' + j,
                    layers: [
                      obj.getTileLayer(),
                      new VectorLayer({ source: progresivas, style: obj.progresiva_style, zIndex: 998 }),
                      new VectorLayer({ source: progresivas2, style: obj.progresiva_style, zIndex: 998 }),
                      new VectorLayer({ source: progresivas4, style: obj.progresiva_style, zIndex: 998 })
                    ],
                    view: new View({
                      projection: 'EPSG:4326',
                      center: [ -72.93, -11.7 ],
                      zoom: 10
                    })
                  })
                  mapx.addLayer(
                    new VectorLayer({
                      source: new VectorSource({
                        features: (new GeoJSON()).readFeatures(pluviometrosJson)
                      }),
                      style: obj.pluviometro_style,
                      zIndex: 999
                    })
                  )

                  mapx.addLayer(new VectorLayer({
                    source: new VectorSource({ features: features }),
                    style: obj.style_proyecto(),
                    zIndex: 997
                  }))

                  mapx.addLayer(obj.lluvia)
                  obj.mapas.push(mapx)
                  mapx.getView().fit(extentx)
                  var fevent = function (e) {
                    // console.log(e.target.values_.resolution)
                    if (e.target.values_.resolution > 0.00034332275390625) {
                      mapx.getLayers().array_[2].setVisible(false)
                      mapx.getLayers().array_[1].setVisible(false)
                    } else if (e.target.values_.resolution > 0.0000858306884765625) {
                      mapx.getLayers().array_[2].setVisible(true)
                      mapx.getLayers().array_[1].setVisible(false)
                    } else {
                      mapx.getLayers().array_[2].setVisible(true)
                      mapx.getLayers().array_[1].setVisible(true)
                    }
                  }
                  mapx.getView().on('change:resolution', fevent)
                  fevent({ target: { values_: { resolution: mapx.getView().getResolution() } } })
                }
              }(val2.data[j].traza__nombre, j))
            )
          }
        })
      })
    },
    color_riesgo (riesgo) {
      switch (riesgo) {
        case 0: return 'rgb(0,128,0)'
        case 1: return 'rgb(0,255,0)'
        case 2: return 'rgb(255,255,0)'
        case 3: return 'rgb(255,128,0)'
        case 4: return 'rgb(255,0,0)'
        default: return 'rgb(255,255,255)'
      }
    },
    texto_tipo (tipo) {
      switch (tipo) {
        case 'erosion': return 'Erosión'
        case 'socavacion': return 'Socavación'
        case 'remocion': return 'Remoción en masa'
        default: return ''
      }
    },
    texto_param (numero, param = null) {
      if (param === null) {
        param = this.param
      }
      switch (param) {
        case 'po': {
          var ipo = parseFloat(numero) * 10
          switch (ipo) {
            case 0: return 'bajo'
            case 2: return '20%'
            case 4: return '40%'
            case 6: return '60%'
            case 8: return '80%'
            case 10: return '100%'
            default: return ' - '
          }
        }
        case 'consecuencia': {
          switch (numero - 1) {
            case 0: return 'Muy Bajo'
            case 1: return 'Bajo'
            case 2: return 'Medio'
            case 3: return 'Alto'
            case 4: return 'Muy Alto'
            default: return ' - '
          }
        }
        case 'riesgo': {
          switch (numero) {
            case 0: return 'Muy Bajo'
            case 1: return 'Bajo'
            case 2: return 'Medio'
            case 3: return 'Alto'
            case 4: return 'Muy Alto'
            default: return ' - '
          }
        }
        default:
          return ' -- '
      }
    },
    style_proyecto () {
      var obj = this
      var outlineColor = 'black'
      return function (feature) {
        var color = obj.color_riesgo(feature.get('riesgo'))
        var style = [ new Style({
          stroke: new Stroke({ color: outlineColor, lineDash: null, lineCap: 'round', lineJoin: 'round', width: 10 })
        }), new Style({
          stroke: new Stroke({ color: color, lineDash: null, lineCap: 'round', lineJoin: 'round', width: 9 })
        })]
        return style
      }
    }
  },
  watch: {
    fecha: function (val, orig) {
      var dval = new Date(val)
      this.actualizar(dval)
    }
  },
  computed: {
    semana: function () {
      var f = new Date(this.fecha)
      var onejan = new Date(f.getFullYear(), 0, 1)
      return f.getFullYear() + '- Semana ' + Math.ceil((((f - onejan) / 86400000) + onejan.getDay() + 1) / 7)
    }
  }
}
</script>

<style>
@media print {
  * {
    -webkit-transition: none !important;
    transition: none !important;
  }
  .col-print-1 {width:8%;  float:left;}
  .col-print-2 {width:16%; float:left;}
  .col-print-3 {width:25%; float:left;}
  .col-print-4 {width:33%; float:left;}
  .col-print-5 {width:42%; float:left;}
  .col-print-6 {width:50%; float:left;}
  .col-print-7 {width:58%; float:left;}
  .col-print-8 {width:66%; float:left;}
  .col-print-9 {width:75%; float:left;}
  .col-print-10{width:83%; float:left;}
  .col-print-11{width:92%; float:left;}
  .col-print-12{width:100%; float:left;}
}
</style>
